<button
	app-session-attachments-button
	[attachmentsCount]="attachmentsCount"
	[goCdkPopover]="attachmentsTemplate"
	goCdkPopoverTrigger="click"
	goCdkPopoverPosition="below"
	goCdkPopoverBgColor="var(--color-off-white)"
	goCdkPopoverShowArrow="true">
</button>

<ng-template #attachmentsTemplate>
	<div>
		<span translate="feedback-session-header_presenter-attachments"></span>
		<session-attachments
			[session]="session"
			[group]="group"
			[user]="user"
			[readonlyMode]="readonlyMode"
			[activityName]="activityName">
		</session-attachments>
		@if (!readonlyMode && attachmentsCount === 0) {
			<h5
				translate="feedback-session-header_add-attachments">
			</h5>
		}
	</div>
</ng-template>
